import Button from "@ch/components/Buttons/Button";
import Modal from "@ch/components/Modals/Modal";
import delay from "@ch/helpers/utils/delay";
import { type FC, useEffect } from "react";

interface KemICSessionCompleteModalProps {
  modalId: string;
  onClose: () => void;
}

const KemICSessionCompleteModal: FC<KemICSessionCompleteModalProps> = ({
  modalId,
  onClose,
}) => {
  useEffect(() => {
    let cancelled = false;

    void (async () => {
      await delay(100);
      if (cancelled) return;

      const dialogue = document.getElementById(
        modalId,
      ) as HTMLDialogElement | null;

      if (!dialogue || dialogue.open) return;

      dialogue.showModal();
    })();

    return () => {
      cancelled = true;

      const dialogue = document.getElementById(
        modalId,
      ) as HTMLDialogElement | null;

      if (dialogue?.open) {
        dialogue.close();
      }
    };
  }, [modalId]);

  return (
    <Modal
      closeOnClickESC={false}
      closeOnClickOutside={false}
      footerComponent={
        <div className="flex w-full justify-center">
          <Button
            className="w-full min-w-[120px] max-w-full px-6"
            onClick={() => {
              const dialogue = document.getElementById(
                modalId,
              ) as HTMLDialogElement | null;
              dialogue?.close();
            }}
            type="button"
          >
            Close
          </Button>
        </div>
      }
      isModalOpen
      modalBoxClassName="md:w-[480px] !h-fit"
      modalId={modalId}
      onDismiss={onClose}
      showCloseIcon={false}
    >
      <div className="mt-3 md:mt-0 md:pt-4">
        <div className="flex flex-col gap-3 pb-4">
          <p className="text-lg font-semibold">Intake Complete!</p>
          <p className="text-base">
            Your intake coordination has been completed successfully. You can
            close this popup to view your summary and chat with Kem
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default KemICSessionCompleteModal;
